import { vModelCheckbox as _vModelCheckbox, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "custom-toggle"
};

var _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  "class": "custom-toggle-slider rounded-circle"
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("label", _hoisted_1, [_withDirectives(_createElementVNode("input", _mergeProps({
    type: "checkbox",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $options.model = $event;
    })
  }, _ctx.$attrs), null, 16), [[_vModelCheckbox, $options.model]]), _hoisted_2]);
}